import { render, staticRenderFns } from "./IconArrowTop.vue?vue&type=template&id=03b2c838&"
import script from "./IconArrowTop.vue?vue&type=script&lang=js&"
export * from "./IconArrowTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports